"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultRateCalculator = void 0;
const models_1 = require("../models");
const face_amount_calculator_1 = require("./face-amount-calculator");
const premium_calculator_1 = require("./premium-calculator");
function calculate(options, rate, faceFactor, premiumFactor) {
    if (!premiumFactor || !faceFactor) {
        return models_1.emptyFaceAndPremium();
    }
    const faceAmount = face_amount_calculator_1.calculateFaceAmount(options, rate, faceFactor);
    const premium = premium_calculator_1.calculatePremium(options, rate, faceFactor, premiumFactor);
    return { faceAmount, premium };
}
exports.DefaultRateCalculator = { calculate };
//# sourceMappingURL=default-rate-calculator.js.map